import { CircularProgress } from '@mui/material';
import styled from 'styled-components';

const ScreenLoader = (props) => {
  return (
    <Wrapper {...props}>
      <CircularProgress style={{ color: '#fff' }} size="55px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 999999;
`;
export default ScreenLoader;
